import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getResponsables } from "../../../../redux/actions/empleador";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledNuevaObra } from "../../../styled/Obras";
import FechaPresentacionObra from "../commons/FechaPresentacionObra";
import ResponsablesObraForm from "./ResponsablesObraForm";

const initialValues = {
    nombreApellidoContacto: "",
    dniContacto: "",
    telefonoContacto: "",
    mailContacto: "",
    responsableSeguridadHigiene: null,
    responsableEmpleador: null,
}

const ResponsablesContainerObra = ({ handleSubmitLastForm, handleCancel }) => {
    const dispatch = useDispatch();
    const responsables = useSelector(
        (state) => state.obra.postNuevaObra.responsables
    );
    const responsablesOptions = useSelector((state) => state.empleador.responsables.data);
    const [formModel, setFormModel] = useState();
    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        if (responsablesOptions.length === 0) {
            dispatch(getResponsables())
            .finally(() => {
                setInitialLoading(false);
            })
        } else {
            setInitialLoading(false);
        }
    }, [])

    useEffect(() => {
        if (Object.keys(responsables).length > 0) {
            setFormModel({ ...initialValues, ...responsables });
        } else {
            setFormModel(initialValues);
        }
    }, [responsables]);
    if (formModel === undefined) return <></>
    return (
        <>
            {initialLoading ?
                (<CircularLoading />)
                : (
                    <StyledNuevaObra.TableContainer >
                        <FechaPresentacionObra />
                        <StyledNuevaObra.LabelContainer>
                            <StyledNuevaObra.Icon component={ErrorOutlineIcon} />
                            <Typography>Al finalizar la carga, el sistema te redirigirá a la grilla de gestión de la obra y, si corresponde, mostrará el número de obra. Desde allí podrás consultar archivos y gestionar el Programa de Seguridad, así como extender, suspender, reiniciar o finalizar la obra.</Typography>
                        </StyledNuevaObra.LabelContainer>

                        <ResponsablesObraForm
                            handleSubmitLastForm={handleSubmitLastForm}
                            formModel={formModel}
                            handleCancel={handleCancel}
                        />

                    </StyledNuevaObra.TableContainer>
                )}
        </>
    )
}

export default ResponsablesContainerObra;